import { String, Static, Boolean, Object, Optional } from '@sinclair/typebox';

import { assertUnreachable, ValueOf } from '../../utils/types';

export const BonusProgram = Object({
  bonusProgramKey: String(),
  loyaltyNumber: String(),
  earnPoints: Boolean(),
  currentTierCode: Optional(String()),
});

export type BonusProgram = Static<typeof BonusProgram>;

export const ValidateFrequentFlyerProgram = Object({
  loyaltyNumber: String(),
  bonusProgramKey: String(),
  firstName: String(),
  lastName: String(),
  channel: String(),
});

export type ValidateFrequentFlyerProgramBody = Static<typeof ValidateFrequentFlyerProgram>;

export type TierLevel = ValueOf<typeof TierLevel>;
export const TierLevel = {
  BASIC: 'BASIC',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  DIAMOND: 'DIAMOND',
  PANDION: 'PANDION',
} as const;

export type TierCode = ValueOf<typeof TierCode>;
export const TierCode = {
  BASIC: 'EBB',
  SILVER: 'EBS',
  GOLD: 'EBG',
  DIAMOND: 'EBD',
  PANDION: 'EBP',
} as const;

export function getTierLevel(code: TierCode): TierLevel {
  switch (code) {
    case TierCode.BASIC:
      return TierLevel.BASIC;
    case TierCode.SILVER:
      return TierLevel.SILVER;
    case TierCode.GOLD:
      return TierLevel.GOLD;
    case TierCode.DIAMOND:
      return TierLevel.DIAMOND;
    case TierCode.PANDION:
      return TierLevel.PANDION;
    default:
      assertUnreachable(code);
  }
}

export function getTierCode(level: TierLevel): TierCode {
  switch (level) {
    case TierLevel.BASIC:
      return TierCode.BASIC;
    case TierLevel.SILVER:
      return TierCode.SILVER;
    case TierLevel.GOLD:
      return TierCode.GOLD;
    case TierLevel.DIAMOND:
      return TierCode.DIAMOND;
    case TierLevel.PANDION:
      return TierCode.PANDION;
    default:
      assertUnreachable(level);
  }
}
